import { ThemeDefinition } from 'vuetify';

export const religion: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#D37777',
    'on-subject-original': '#FFFFFF',
    subject: '#C64E4E',
    'on-subject': '#FFFFFF',
    primary: '#9E3333',
    'on-primary': '#FFFFFF',
    'primary-container': '#ECC5C5',
    'on-primary-container': '#2E0F0F',
    secondary: '#6D5050',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#DED3D3',
    'on-secondary-container': '#231A1A',
    surface: '#FCF7F7',
    'on-surface': '#201D1D',
    'on-surface-medium': '#504949',
    'on-surface-low': '#9E9494',
    outline: '#867979',
    'outline-variant': '#CFC9C9',
    'inverse-surface': '#422424',
    'inverse-on-surface': '#F6EEEE',
    'inverse-primary': '#E6B2B2',
    'surface-dim': '#EBC2C2',
    'surface-bright': '#FEFBFB',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#FAF0F0',
    'surface-container': '#F7E8E8',
    'surface-container-high': '#F2D9D9',
    'surface-container-highest': '#F0D1D1',
  },
};

export const religionDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#D37777',
    'on-subject-original': '#F7FCFA',
    subject: '#E1A3A3',
    'on-subject': '#2E0F0F',
    primary: '#732626',
    'on-primary': '#F9ECEC',
    'primary-container': '#732626',
    'on-primary-container': '#F9ECEC',
    secondary: '#DACDCD',
    'on-secondary': '#231A1A',
    'secondary-container': '#584141',
    'on-secondary-container': '#F4F1F1',
    surface: '#181010',
    'on-surface': '#F3F2F2',
    'on-surface-medium': '#CFC9C9',
    'on-surface-low': '#867979',
    outline: '#9E9494',
    'outline-variant': '#6B6161',
    'inverse-surface': '#EDDEDE',
    'inverse-on-surface': '#281515',
    'inverse-primary': '#4D1919',
    'surface-dim': '#150E0E',
    'surface-bright': '#462F2F',
    'surface-container-lowest': '#120C0C',
    'surface-container-low': '#1E1515',
    'surface-container': '#281B1B',
    'surface-container-high': '#342323',
    'surface-container-highest': '#432D2D',
  },
};
